export enum AppSearchWindowState {
  Idle = 'idle',
  Loading = 'loading',
  Results = 'results',
  Refreshing = 'refreshing',
  Empty = 'empty',
  Error = 'error',
}
